import React from 'react';
import { ClipboardList } from 'lucide-react';
import type { SettingsSectionItem } from '~/libraries/settings/SettingsSection';
import { LibrarySection } from '../../shared/LibrarySection';
import { PageLayout } from '~/shared/PageLayout';
import { InterventionDefinitionTable } from './InterventionDefinitionTable';

export const InterventionDefinitionLibrarySection = {
	settingsView: 'intervention-definitions',
	title: 'Intervention Definitions',
	description: 'Manage intervention definitions',
	TitleIcon: ClipboardList
} satisfies SettingsSectionItem;

export function InterventionDefinitionLibrary() {
	return (
		<PageLayout
			pageHeader={{
				title: InterventionDefinitionLibrarySection.title,
				description: InterventionDefinitionLibrarySection.description,
				TitleIcon: InterventionDefinitionLibrarySection.TitleIcon
			}}
		>
			<LibrarySection
				librarySection={InterventionDefinitionLibrarySection}
				searchPlaceholder="Search task definitions by name..."
				noResultsLabel="No Intervention Definitions Found"
				noResultsSubLabel="Intervention definitions are seeded from configuration files"
				TableComponent={InterventionDefinitionTable}
				searchFilterColumn="title"
			/>
		</PageLayout>
	);
}
